class OurPromise extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      document.addEventListener("DOMContentLoaded", () => {
        console.log("ss Before", this.dataset.items);

        const items = this.dataset.items || 3; // fallback value
        console.log("ss after", items);

        const carousel = this.querySelector('.owl-carousel');
        if (carousel) {
          $(carousel).owlCarousel({
            items: Number(items),
            loop: true,
            margin: 0,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            responsive: {
              0: {
                items: Number(items),
              },
            },
          });
        } else {
          console.warn("No .owl-carousel element found within <our-promise>.");
        }
      });
    }
  }
}

customElements.define('our-promise', OurPromise);
